"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7538],{

/***/ 435:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "startRecording": function() { return /* binding */ startRecording; }
});

// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/telemetry/telemetry.js + 1 modules
var telemetry_telemetry = __webpack_require__(18797);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/transport/httpRequest.js + 1 modules
var transport_httpRequest = __webpack_require__(30481);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/transport/eventBridge.js
var eventBridge = __webpack_require__(76876);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/sendToExtension.js
var sendToExtension = __webpack_require__(38971);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-rum/esm/domain/replayStats.js
var replayStats = __webpack_require__(98290);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/functionUtils.js
var functionUtils = __webpack_require__(251);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/browser/addEventListener.js
var addEventListener = __webpack_require__(83206);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/urlPolyfill.js
var urlPolyfill = __webpack_require__(70170);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-rum-core/esm/index.js + 118 modules
var esm = __webpack_require__(84547);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/serialization/serializationUtils.js


const serializedNodeIds = new WeakMap();
function hasSerializedNode(node) {
    return serializedNodeIds.has(node);
}
function nodeAndAncestorsHaveSerializedNode(node) {
    let current = node;
    while (current) {
        if (!hasSerializedNode(current) && !(0,esm/* isNodeShadowRoot */.VO)(current)) {
            return false;
        }
        current = (0,esm/* getParentNode */.Ow)(current);
    }
    return true;
}
function getSerializedNodeId(node) {
    return serializedNodeIds.get(node);
}
function setSerializedNodeId(node, serializeNodeId) {
    serializedNodeIds.set(node, serializeNodeId);
}
/**
 * Get the element "value" to be serialized as an attribute or an input update record. It respects
 * the input privacy mode of the element.
 * PERFROMANCE OPTIMIZATION: Assumes that privacy level `HIDDEN` is never encountered because of earlier checks.
 */
function getElementInputValue(element, nodePrivacyLevel) {
    /*
     BROWSER SPEC NOTE: <input>, <select>
     For some <input> elements, the `value` is an exceptional property/attribute that has the
     value synced between el.value and el.getAttribute()
     input[type=button,checkbox,hidden,image,radio,reset,submit]
     */
    const tagName = element.tagName;
    const value = element.value;
    if ((0,esm/* shouldMaskNode */.gR)(element, nodePrivacyLevel)) {
        const type = element.type;
        if (tagName === 'INPUT' && (type === 'button' || type === 'submit' || type === 'reset')) {
            // Overrule `MASK` privacy level for button-like element values, as they are used during replay
            // to display their label. They can still be hidden via the "hidden" privacy attribute or class name.
            return value;
        }
        else if (!value || tagName === 'OPTION') {
            // <Option> value provides no benefit
            return;
        }
        return esm/* CENSORED_STRING_MARK */.k6;
    }
    if (tagName === 'OPTION' || tagName === 'SELECT') {
        return element.value;
    }
    if (tagName !== 'INPUT' && tagName !== 'TEXTAREA') {
        return;
    }
    return value;
}
const URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")([^"]*)"|([^)]*))\)/gm;
const ABSOLUTE_URL = /^[A-Za-z]+:|^\/\//;
const DATA_URI = /^["']?data:.*,/i;
function switchToAbsoluteUrl(cssText, cssHref) {
    return cssText.replace(URL_IN_CSS_REF, (matchingSubstring, singleQuote, urlWrappedInSingleQuotes, doubleQuote, urlWrappedInDoubleQuotes, urlNotWrappedInQuotes) => {
        const url = urlWrappedInSingleQuotes || urlWrappedInDoubleQuotes || urlNotWrappedInQuotes;
        if (!cssHref || !url || ABSOLUTE_URL.test(url) || DATA_URI.test(url)) {
            return matchingSubstring;
        }
        const quote = singleQuote || doubleQuote || '';
        return `url(${quote}${makeUrlAbsolute(url, cssHref)}${quote})`;
    });
}
function makeUrlAbsolute(url, baseUrl) {
    try {
        return (0,urlPolyfill/* buildUrl */.Q2)(url, baseUrl).href;
    }
    catch (_a) {
        return url;
    }
}
const TAG_NAME_REGEX = /[^a-z1-6-_]/;
function getValidTagName(tagName) {
    const processedTagName = tagName.toLowerCase().trim();
    if (TAG_NAME_REGEX.test(processedTagName)) {
        // if the tag name is odd and we cannot extract
        // anything from the string, then we return a
        // generic div
        return 'div';
    }
    return processedTagName;
}
function censoredImageForSize(width, height) {
    return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='${width}' height='${height}' style='background-color:silver'%3E%3C/svg%3E`;
}
//# sourceMappingURL=serializationUtils.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/timeUtils.js
var timeUtils = __webpack_require__(25026);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/types/sessionReplayConstants.js
const RecordType = {
    FullSnapshot: 2,
    IncrementalSnapshot: 3,
    Meta: 4,
    Focus: 6,
    ViewEnd: 7,
    VisualViewport: 8,
    FrustrationRecord: 9,
};
const NodeType = {
    Document: 0,
    DocumentType: 1,
    Element: 2,
    Text: 3,
    CDATA: 4,
    DocumentFragment: 11,
};
const IncrementalSource = {
    Mutation: 0,
    MouseMove: 1,
    MouseInteraction: 2,
    Scroll: 3,
    ViewportResize: 4,
    Input: 5,
    TouchMove: 6,
    MediaInteraction: 7,
    StyleSheetRule: 8,
    // CanvasMutation : 9,
    // Font : 10,
};
const MouseInteractionType = {
    MouseUp: 0,
    MouseDown: 1,
    Click: 2,
    ContextMenu: 3,
    DblClick: 4,
    Focus: 5,
    Blur: 6,
    TouchStart: 7,
    TouchEnd: 9,
};
const MediaInteractionType = {
    Play: 0,
    Pause: 1,
};
//# sourceMappingURL=sessionReplayConstants.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/types/index.js

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/serialization/serializeStyleSheets.js
function serializeStyleSheets(cssStyleSheets) {
    if (cssStyleSheets === undefined || cssStyleSheets.length === 0) {
        return undefined;
    }
    return cssStyleSheets.map((cssStyleSheet) => {
        const rules = cssStyleSheet.cssRules || cssStyleSheet.rules;
        const cssRules = Array.from(rules, (cssRule) => cssRule.cssText);
        const styleSheet = {
            cssRules,
            disabled: cssStyleSheet.disabled || undefined,
            media: cssStyleSheet.media.length > 0 ? Array.from(cssStyleSheet.media) : undefined,
        };
        return styleSheet;
    });
}
//# sourceMappingURL=serializeStyleSheets.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/browserDetection.js
var browserDetection = __webpack_require__(12172);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/serialization/serializeAttribute.js


// TODO: temporarily bump the Session Replay limit to 1Mb for dataUrls
// This limit should be removed after [PANA-2843] is implemented
const MAX_ATTRIBUTE_VALUE_CHAR_LENGTH = 1000000;
function serializeAttribute(element, nodePrivacyLevel, attributeName, configuration) {
    if (nodePrivacyLevel === esm/* NodePrivacyLevel.HIDDEN */.zx.HIDDEN) {
        // dup condition for direct access case
        return null;
    }
    const attributeValue = element.getAttribute(attributeName);
    if (nodePrivacyLevel === esm/* NodePrivacyLevel.MASK */.zx.MASK &&
        attributeName !== esm/* PRIVACY_ATTR_NAME */.$n &&
        !esm/* STABLE_ATTRIBUTES.includes */.YO.includes(attributeName) &&
        attributeName !== configuration.actionNameAttribute) {
        const tagName = element.tagName;
        switch (attributeName) {
            // Mask Attribute text content
            case 'title':
            case 'alt':
            case 'placeholder':
                return esm/* CENSORED_STRING_MARK */.k6;
        }
        // mask image URLs
        if (tagName === 'IMG' && (attributeName === 'src' || attributeName === 'srcset')) {
            // generate image with similar dimension than the original to have the same rendering behaviour
            const image = element;
            if (image.naturalWidth > 0) {
                return censoredImageForSize(image.naturalWidth, image.naturalHeight);
            }
            const { width, height } = element.getBoundingClientRect();
            if (width > 0 || height > 0) {
                return censoredImageForSize(width, height);
            }
            // if we can't get the image size, fallback to the censored image
            return esm/* CENSORED_IMG_MARK */.Xn;
        }
        // mask source URLs
        if (tagName === 'SOURCE' && (attributeName === 'src' || attributeName === 'srcset')) {
            return esm/* CENSORED_IMG_MARK */.Xn;
        }
        // mask <a> URLs
        if (tagName === 'A' && attributeName === 'href') {
            return esm/* CENSORED_STRING_MARK */.k6;
        }
        // mask data-* attributes
        if (attributeValue && attributeName.startsWith('data-')) {
            // Exception: it's safe to reveal the `${PRIVACY_ATTR_NAME}` attr
            return esm/* CENSORED_STRING_MARK */.k6;
        }
        // mask iframe srcdoc
        if (tagName === 'IFRAME' && attributeName === 'srcdoc') {
            return esm/* CENSORED_STRING_MARK */.k6;
        }
    }
    if (!attributeValue || typeof attributeValue !== 'string') {
        return attributeValue;
    }
    return (0,esm/* sanitizeIfLongDataUrl */.Pu)(attributeValue, MAX_ATTRIBUTE_VALUE_CHAR_LENGTH);
}
//# sourceMappingURL=serializeAttribute.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/serialization/serializationStats.js
function createSerializationStats() {
    return {
        cssText: {
            count: 0,
            max: 0,
            sum: 0,
        },
        serializationDuration: {
            count: 0,
            max: 0,
            sum: 0,
        },
    };
}
function updateSerializationStats(stats, metric, value) {
    stats[metric].count += 1;
    stats[metric].max = Math.max(stats[metric].max, value);
    stats[metric].sum += value;
}
function aggregateSerializationStats(aggregateStats, stats) {
    for (const metric of ['cssText', 'serializationDuration']) {
        aggregateStats[metric].count += stats[metric].count;
        aggregateStats[metric].max = Math.max(aggregateStats[metric].max, stats[metric].max);
        aggregateStats[metric].sum += stats[metric].sum;
    }
}
//# sourceMappingURL=serializationStats.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/serialization/serializeAttributes.js





function serializeAttributes(element, nodePrivacyLevel, options) {
    if (nodePrivacyLevel === esm/* NodePrivacyLevel.HIDDEN */.zx.HIDDEN) {
        return {};
    }
    const safeAttrs = {};
    const tagName = getValidTagName(element.tagName);
    const doc = element.ownerDocument;
    for (let i = 0; i < element.attributes.length; i += 1) {
        const attribute = element.attributes.item(i);
        const attributeName = attribute.name;
        const attributeValue = serializeAttribute(element, nodePrivacyLevel, attributeName, options.configuration);
        if (attributeValue !== null) {
            safeAttrs[attributeName] = attributeValue;
        }
    }
    if (element.value &&
        (tagName === 'textarea' || tagName === 'select' || tagName === 'option' || tagName === 'input')) {
        const formValue = getElementInputValue(element, nodePrivacyLevel);
        if (formValue !== undefined) {
            safeAttrs.value = formValue;
        }
    }
    /**
     * <Option> can be selected, which occurs if its `value` matches ancestor `<Select>.value`
     */
    if (tagName === 'option' && nodePrivacyLevel === esm/* NodePrivacyLevel.ALLOW */.zx.ALLOW) {
        // For privacy=`MASK`, all the values would be the same, so skip.
        const optionElement = element;
        if (optionElement.selected) {
            safeAttrs.selected = optionElement.selected;
        }
    }
    // remote css
    if (tagName === 'link') {
        const stylesheet = Array.from(doc.styleSheets).find((s) => s.href === element.href);
        const cssText = getCssRulesString(stylesheet);
        if (cssText && stylesheet) {
            updateSerializationStats(options.serializationContext.serializationStats, 'cssText', cssText.length);
            safeAttrs._cssText = cssText;
        }
    }
    // dynamic stylesheet
    if (tagName === 'style' && element.sheet) {
        const cssText = getCssRulesString(element.sheet);
        if (cssText) {
            updateSerializationStats(options.serializationContext.serializationStats, 'cssText', cssText.length);
            safeAttrs._cssText = cssText;
        }
    }
    /**
     * Forms: input[type=checkbox,radio]
     * The `checked` property for <input> is a little bit special:
     * 1. el.checked is a setter that returns if truthy.
     * 2. getAttribute returns the string value
     * getAttribute('checked') does not sync with `Element.checked`, so use JS property
     * NOTE: `checked` property exists on `HTMLInputElement`. For serializer assumptions, we check for type=radio|check.
     */
    const inputElement = element;
    if (tagName === 'input' && (inputElement.type === 'radio' || inputElement.type === 'checkbox')) {
        if (nodePrivacyLevel === esm/* NodePrivacyLevel.ALLOW */.zx.ALLOW) {
            safeAttrs.checked = !!inputElement.checked;
        }
        else if ((0,esm/* shouldMaskNode */.gR)(inputElement, nodePrivacyLevel)) {
            delete safeAttrs.checked;
        }
    }
    /**
     * Serialize the media playback state
     */
    if (tagName === 'audio' || tagName === 'video') {
        const mediaElement = element;
        safeAttrs.rr_mediaState = mediaElement.paused ? 'paused' : 'played';
    }
    /**
     * Serialize the scroll state for each element only for full snapshot
     */
    let scrollTop;
    let scrollLeft;
    const serializationContext = options.serializationContext;
    switch (serializationContext.status) {
        case 0 /* SerializationContextStatus.INITIAL_FULL_SNAPSHOT */:
            scrollTop = Math.round(element.scrollTop);
            scrollLeft = Math.round(element.scrollLeft);
            if (scrollTop || scrollLeft) {
                serializationContext.elementsScrollPositions.set(element, { scrollTop, scrollLeft });
            }
            break;
        case 1 /* SerializationContextStatus.SUBSEQUENT_FULL_SNAPSHOT */:
            if (serializationContext.elementsScrollPositions.has(element)) {
                ;
                ({ scrollTop, scrollLeft } = serializationContext.elementsScrollPositions.get(element));
            }
            break;
    }
    if (scrollLeft) {
        safeAttrs.rr_scrollLeft = scrollLeft;
    }
    if (scrollTop) {
        safeAttrs.rr_scrollTop = scrollTop;
    }
    return safeAttrs;
}
function getCssRulesString(cssStyleSheet) {
    if (!cssStyleSheet) {
        return null;
    }
    let rules;
    try {
        rules = cssStyleSheet.rules || cssStyleSheet.cssRules;
    }
    catch (_a) {
        // if css is protected by CORS we cannot access cssRules see: https://www.w3.org/TR/cssom-1/#the-cssstylesheet-interface
    }
    if (!rules) {
        return null;
    }
    const styleSheetCssText = Array.from(rules, (0,browserDetection/* isSafari */.G6)() ? getCssRuleStringForSafari : getCssRuleString).join('');
    return switchToAbsoluteUrl(styleSheetCssText, cssStyleSheet.href);
}
function getCssRuleStringForSafari(rule) {
    // Safari does not escape attribute selectors containing : properly
    // https://bugs.webkit.org/show_bug.cgi?id=184604
    if (isCSSStyleRule(rule) && rule.selectorText.includes(':')) {
        // This regex replaces [foo:bar] by [foo\\:bar]
        const escapeColon = /(\[[\w-]+[^\\])(:[^\]]+\])/g;
        return rule.cssText.replace(escapeColon, '$1\\$2');
    }
    return getCssRuleString(rule);
}
function getCssRuleString(rule) {
    // If it's an @import rule, try to inline sub-rules recursively with `getCssRulesString`. This
    // operation can fail if the imported stylesheet is protected by CORS, in which case we fallback
    // to the @import rule CSS text.
    return (isCSSImportRule(rule) && getCssRulesString(rule.styleSheet)) || rule.cssText;
}
function isCSSImportRule(rule) {
    return 'styleSheet' in rule;
}
function isCSSStyleRule(rule) {
    return 'selectorText' in rule;
}
//# sourceMappingURL=serializeAttributes.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/serialization/serializeNode.js





function serializeNodeWithId(node, options) {
    const serializedNode = serializeNode(node, options);
    if (!serializedNode) {
        return null;
    }
    // Try to reuse the previous id
    const id = getSerializedNodeId(node) || generateNextId();
    const serializedNodeWithId = serializedNode;
    serializedNodeWithId.id = id;
    setSerializedNodeId(node, id);
    if (options.serializedNodeIds) {
        options.serializedNodeIds.add(id);
    }
    return serializedNodeWithId;
}
let _nextId = 1;
function generateNextId() {
    return _nextId++;
}
function serializeChildNodes(node, options) {
    const result = [];
    (0,esm/* forEachChildNodes */.Uo)(node, (childNode) => {
        const serializedChildNode = serializeNodeWithId(childNode, options);
        if (serializedChildNode) {
            result.push(serializedChildNode);
        }
    });
    return result;
}
function serializeNode(node, options) {
    switch (node.nodeType) {
        case node.DOCUMENT_NODE:
            return serializeDocumentNode(node, options);
        case node.DOCUMENT_FRAGMENT_NODE:
            return serializeDocumentFragmentNode(node, options);
        case node.DOCUMENT_TYPE_NODE:
            return serializeDocumentTypeNode(node);
        case node.ELEMENT_NODE:
            return serializeElementNode(node, options);
        case node.TEXT_NODE:
            return serializeTextNode(node, options);
        case node.CDATA_SECTION_NODE:
            return serializeCDataNode();
    }
}
function serializeDocumentNode(document, options) {
    return {
        type: NodeType.Document,
        childNodes: serializeChildNodes(document, options),
        adoptedStyleSheets: serializeStyleSheets(document.adoptedStyleSheets),
    };
}
function serializeDocumentFragmentNode(element, options) {
    const isShadowRoot = (0,esm/* isNodeShadowRoot */.VO)(element);
    if (isShadowRoot) {
        options.serializationContext.shadowRootsController.addShadowRoot(element);
    }
    return {
        type: NodeType.DocumentFragment,
        childNodes: serializeChildNodes(element, options),
        isShadowRoot,
        adoptedStyleSheets: isShadowRoot ? serializeStyleSheets(element.adoptedStyleSheets) : undefined,
    };
}
function serializeDocumentTypeNode(documentType) {
    return {
        type: NodeType.DocumentType,
        name: documentType.name,
        publicId: documentType.publicId,
        systemId: documentType.systemId,
    };
}
/**
 * Serializing Element nodes involves capturing:
 * 1. HTML ATTRIBUTES:
 * 2. JS STATE:
 * - scroll offsets
 * - Form fields (input value, checkbox checked, option selection, range)
 * - Canvas state,
 * - Media (video/audio) play mode + currentTime
 * - iframe contents
 * - webcomponents
 * 3. CUSTOM PROPERTIES:
 * - height+width for when `hidden` to cover the element
 * 4. EXCLUDED INTERACTION STATE:
 * - focus (possible, but not worth perf impact)
 * - hover (tracked only via mouse activity)
 * - fullscreen mode
 */
function serializeElementNode(element, options) {
    const tagName = getValidTagName(element.tagName);
    const isSVG = isSVGElement(element) || undefined;
    // For performance reason, we don't use getNodePrivacyLevel directly: we leverage the
    // parentNodePrivacyLevel option to avoid iterating over all parents
    const nodePrivacyLevel = (0,esm/* reducePrivacyLevel */.Ch)((0,esm/* getNodeSelfPrivacyLevel */.SZ)(element), options.parentNodePrivacyLevel);
    if (nodePrivacyLevel === esm/* NodePrivacyLevel.HIDDEN */.zx.HIDDEN) {
        const { width, height } = element.getBoundingClientRect();
        return {
            type: NodeType.Element,
            tagName,
            attributes: {
                rr_width: `${width}px`,
                rr_height: `${height}px`,
                [esm/* PRIVACY_ATTR_NAME */.$n]: esm/* PRIVACY_ATTR_VALUE_HIDDEN */.nw,
            },
            childNodes: [],
            isSVG,
        };
    }
    // Ignore Elements like Script and some Link, Metas
    if (nodePrivacyLevel === esm/* NodePrivacyLevel.IGNORE */.zx.IGNORE) {
        return;
    }
    const attributes = serializeAttributes(element, nodePrivacyLevel, options);
    let childNodes = [];
    if ((0,esm/* hasChildNodes */.Sn)(element) &&
        // Do not serialize style children as the css rules are already in the _cssText attribute
        tagName !== 'style') {
        // OBJECT POOLING OPTIMIZATION:
        // We should not create a new object systematically as it could impact performances. Try to reuse
        // the same object as much as possible, and clone it only if we need to.
        let childNodesSerializationOptions;
        if (options.parentNodePrivacyLevel === nodePrivacyLevel && options.ignoreWhiteSpace === (tagName === 'head')) {
            childNodesSerializationOptions = options;
        }
        else {
            childNodesSerializationOptions = {
                ...options,
                parentNodePrivacyLevel: nodePrivacyLevel,
                ignoreWhiteSpace: tagName === 'head',
            };
        }
        childNodes = serializeChildNodes(element, childNodesSerializationOptions);
    }
    return {
        type: NodeType.Element,
        tagName,
        attributes,
        childNodes,
        isSVG,
    };
}
function isSVGElement(el) {
    return el.tagName === 'svg' || el instanceof SVGElement;
}
/**
 * Text Nodes are dependant on Element nodes
 * Privacy levels are set on elements so we check the parentElement of a text node
 * for privacy level.
 */
function serializeTextNode(textNode, options) {
    const textContent = (0,esm/* getTextContent */.FB)(textNode, options.ignoreWhiteSpace || false, options.parentNodePrivacyLevel);
    if (textContent === undefined) {
        return;
    }
    return {
        type: NodeType.Text,
        textContent,
    };
}
function serializeCDataNode() {
    return {
        type: NodeType.CDATA,
        textContent: '',
    };
}
//# sourceMappingURL=serializeNode.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/serialization/serializeDocument.js



function serializeDocument(document, configuration, serializationContext) {
    const serializationStart = (0,timeUtils/* timeStampNow */.n$)();
    const serializedNode = serializeNodeWithId(document, {
        serializationContext,
        parentNodePrivacyLevel: configuration.defaultPrivacyLevel,
        configuration,
    });
    updateSerializationStats(serializationContext.serializationStats, 'serializationDuration', (0,timeUtils/* elapsed */._J)(serializationStart, (0,timeUtils/* timeStampNow */.n$)()));
    // We are sure that Documents are never ignored, so this function never returns null
    return serializedNode;
}
//# sourceMappingURL=serializeDocument.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/serialization/index.js





//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/eventsUtils.js

function isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
function getEventTarget(event) {
    if (event.composed === true && (0,esm/* isNodeShadowHost */.aT)(event.target)) {
        return event.composedPath()[0];
    }
    return event.target;
}
//# sourceMappingURL=eventsUtils.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/viewports.js
/**
 * Browsers have not standardized various dimension properties. Mobile devices typically report
 * dimensions in reference to the visual viewport, while desktop uses the layout viewport. For example,
 * Mobile Chrome will change innerWidth when a pinch zoom takes place, while Chrome Desktop (mac) will not.
 *
 * With the new Viewport API, we now calculate and normalize dimension properties to the layout viewport.
 * If the VisualViewport API is not supported by a browser, it isn't reasonably possible to detect or normalize
 * which viewport is being measured. Therefore these exported functions will fallback to assuming that the layout
 * viewport is being measured by the browser
 */
// Scrollbar widths vary across properties on different devices and browsers
const TOLERANCE = 25;
/**
 * Use the Visual Viewport API's properties to measure scrollX/Y in reference to the layout viewport
 * in order to determine if window.scrollX/Y is measuring the layout or visual viewport.
 * This finding corresponds to which viewport mouseEvent.clientX/Y and window.innerWidth/Height measures.
 */
function isVisualViewportFactoredIn(visualViewport) {
    return (Math.abs(visualViewport.pageTop - visualViewport.offsetTop - window.scrollY) > TOLERANCE ||
        Math.abs(visualViewport.pageLeft - visualViewport.offsetLeft - window.scrollX) > TOLERANCE);
}
const convertMouseEventToLayoutCoordinates = (clientX, clientY) => {
    const visualViewport = window.visualViewport;
    const normalized = {
        layoutViewportX: clientX,
        layoutViewportY: clientY,
        visualViewportX: clientX,
        visualViewportY: clientY,
    };
    if (!visualViewport) {
        // On old browsers, we cannot normalize, so fallback to clientX/Y
        return normalized;
    }
    else if (isVisualViewportFactoredIn(visualViewport)) {
        // Typically Mobile Devices
        normalized.layoutViewportX = Math.round(clientX + visualViewport.offsetLeft);
        normalized.layoutViewportY = Math.round(clientY + visualViewport.offsetTop);
    }
    else {
        // Typically Desktop Devices
        normalized.visualViewportX = Math.round(clientX - visualViewport.offsetLeft);
        normalized.visualViewportY = Math.round(clientY - visualViewport.offsetTop);
    }
    return normalized;
};
const getVisualViewport = (visualViewport) => ({
    scale: visualViewport.scale,
    offsetLeft: visualViewport.offsetLeft,
    offsetTop: visualViewport.offsetTop,
    pageLeft: visualViewport.pageLeft,
    pageTop: visualViewport.pageTop,
    height: visualViewport.height,
    width: visualViewport.width,
});
//# sourceMappingURL=viewports.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/assembly.js


function assembleIncrementalSnapshot(source, data) {
    return {
        data: {
            source,
            ...data,
        },
        type: RecordType.IncrementalSnapshot,
        timestamp: (0,timeUtils/* timeStampNow */.n$)(),
    };
}
//# sourceMappingURL=assembly.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/trackers/trackMove.js






const MOUSE_MOVE_OBSERVER_THRESHOLD = 50;
function trackMove(configuration, moveCb) {
    const { throttled: updatePosition, cancel: cancelThrottle } = (0,functionUtils/* throttle */.P)((event) => {
        const target = getEventTarget(event);
        if (hasSerializedNode(target)) {
            const coordinates = tryToComputeCoordinates(event);
            if (!coordinates) {
                return;
            }
            const position = {
                id: getSerializedNodeId(target),
                timeOffset: 0,
                x: coordinates.x,
                y: coordinates.y,
            };
            moveCb(assembleIncrementalSnapshot(isTouchEvent(event) ? IncrementalSource.TouchMove : IncrementalSource.MouseMove, { positions: [position] }));
        }
    }, MOUSE_MOVE_OBSERVER_THRESHOLD, {
        trailing: false,
    });
    const { stop: removeListener } = (0,addEventListener/* addEventListeners */.y)(configuration, document, ["mousemove" /* DOM_EVENT.MOUSE_MOVE */, "touchmove" /* DOM_EVENT.TOUCH_MOVE */], updatePosition, {
        capture: true,
        passive: true,
    });
    return {
        stop: () => {
            removeListener();
            cancelThrottle();
        },
    };
}
function tryToComputeCoordinates(event) {
    let { clientX: x, clientY: y } = isTouchEvent(event) ? event.changedTouches[0] : event;
    if (window.visualViewport) {
        const { visualViewportX, visualViewportY } = convertMouseEventToLayoutCoordinates(x, y);
        x = visualViewportX;
        y = visualViewportY;
    }
    if (!Number.isFinite(x) || !Number.isFinite(y)) {
        if (event.isTrusted) {
            (0,telemetry_telemetry/* addTelemetryDebug */.eJ)('mouse/touch event without x/y');
        }
        return undefined;
    }
    return { x, y };
}
//# sourceMappingURL=trackMove.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/trackers/trackMouseInteraction.js







const eventTypeToMouseInteraction = {
    // Listen for pointerup DOM events instead of mouseup for MouseInteraction/MouseUp records. This
    // allows to reference such records from Frustration records.
    //
    // In the context of supporting Mobile Session Replay, we introduced `PointerInteraction` records
    // used by the Mobile SDKs in place of `MouseInteraction`. In the future, we should replace
    // `MouseInteraction` by `PointerInteraction` in the Browser SDK so we have an uniform way to
    // convey such interaction. This would cleanly solve the issue since we would have
    // `PointerInteraction/Up` records that we could reference from `Frustration` records.
    ["pointerup" /* DOM_EVENT.POINTER_UP */]: MouseInteractionType.MouseUp,
    ["mousedown" /* DOM_EVENT.MOUSE_DOWN */]: MouseInteractionType.MouseDown,
    ["click" /* DOM_EVENT.CLICK */]: MouseInteractionType.Click,
    ["contextmenu" /* DOM_EVENT.CONTEXT_MENU */]: MouseInteractionType.ContextMenu,
    ["dblclick" /* DOM_EVENT.DBL_CLICK */]: MouseInteractionType.DblClick,
    ["focus" /* DOM_EVENT.FOCUS */]: MouseInteractionType.Focus,
    ["blur" /* DOM_EVENT.BLUR */]: MouseInteractionType.Blur,
    ["touchstart" /* DOM_EVENT.TOUCH_START */]: MouseInteractionType.TouchStart,
    ["touchend" /* DOM_EVENT.TOUCH_END */]: MouseInteractionType.TouchEnd,
};
function trackMouseInteraction(configuration, mouseInteractionCb, recordIds) {
    const handler = (event) => {
        const target = getEventTarget(event);
        if ((0,esm/* getNodePrivacyLevel */.IE)(target, configuration.defaultPrivacyLevel) === esm/* NodePrivacyLevel.HIDDEN */.zx.HIDDEN ||
            !hasSerializedNode(target)) {
            return;
        }
        const id = getSerializedNodeId(target);
        const type = eventTypeToMouseInteraction[event.type];
        let interaction;
        if (type !== MouseInteractionType.Blur && type !== MouseInteractionType.Focus) {
            const coordinates = tryToComputeCoordinates(event);
            if (!coordinates) {
                return;
            }
            interaction = { id, type, x: coordinates.x, y: coordinates.y };
        }
        else {
            interaction = { id, type };
        }
        const record = {
            id: recordIds.getIdForEvent(event),
            ...assembleIncrementalSnapshot(IncrementalSource.MouseInteraction, interaction),
        };
        mouseInteractionCb(record);
    };
    return (0,addEventListener/* addEventListeners */.y)(configuration, document, Object.keys(eventTypeToMouseInteraction), handler, {
        capture: true,
        passive: true,
    });
}
//# sourceMappingURL=trackMouseInteraction.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/trackers/trackScroll.js






const SCROLL_OBSERVER_THRESHOLD = 100;
function trackScroll(configuration, scrollCb, elementsScrollPositions, target = document) {
    const { throttled: updatePosition, cancel: cancelThrottle } = (0,functionUtils/* throttle */.P)((event) => {
        const target = getEventTarget(event);
        if (!target ||
            (0,esm/* getNodePrivacyLevel */.IE)(target, configuration.defaultPrivacyLevel) === esm/* NodePrivacyLevel.HIDDEN */.zx.HIDDEN ||
            !hasSerializedNode(target)) {
            return;
        }
        const id = getSerializedNodeId(target);
        const scrollPositions = target === document
            ? {
                scrollTop: (0,esm/* getScrollY */.X_)(),
                scrollLeft: (0,esm/* getScrollX */.$1)(),
            }
            : {
                scrollTop: Math.round(target.scrollTop),
                scrollLeft: Math.round(target.scrollLeft),
            };
        elementsScrollPositions.set(target, scrollPositions);
        scrollCb(assembleIncrementalSnapshot(IncrementalSource.Scroll, {
            id,
            x: scrollPositions.scrollLeft,
            y: scrollPositions.scrollTop,
        }));
    }, SCROLL_OBSERVER_THRESHOLD);
    const { stop: removeListener } = (0,addEventListener/* addEventListener */.O)(configuration, target, "scroll" /* DOM_EVENT.SCROLL */, updatePosition, {
        capture: true,
        passive: true,
    });
    return {
        stop: () => {
            removeListener();
            cancelThrottle();
        },
    };
}
//# sourceMappingURL=trackScroll.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/trackers/trackViewportResize.js





const VISUAL_VIEWPORT_OBSERVER_THRESHOLD = 200;
function trackViewportResize(configuration, viewportResizeCb) {
    const viewportResizeSubscription = (0,esm/* initViewportObservable */.AX)(configuration).subscribe((data) => {
        viewportResizeCb(assembleIncrementalSnapshot(IncrementalSource.ViewportResize, data));
    });
    return {
        stop: () => {
            viewportResizeSubscription.unsubscribe();
        },
    };
}
function trackVisualViewportResize(configuration, visualViewportResizeCb) {
    const visualViewport = window.visualViewport;
    if (!visualViewport) {
        return { stop: functionUtils/* noop */.Z };
    }
    const { throttled: updateDimension, cancel: cancelThrottle } = (0,functionUtils/* throttle */.P)(() => {
        visualViewportResizeCb({
            data: getVisualViewport(visualViewport),
            type: RecordType.VisualViewport,
            timestamp: (0,timeUtils/* timeStampNow */.n$)(),
        });
    }, VISUAL_VIEWPORT_OBSERVER_THRESHOLD, {
        trailing: false,
    });
    const { stop: removeListener } = (0,addEventListener/* addEventListeners */.y)(configuration, visualViewport, ["resize" /* DOM_EVENT.RESIZE */, "scroll" /* DOM_EVENT.SCROLL */], updateDimension, {
        capture: true,
        passive: true,
    });
    return {
        stop: () => {
            removeListener();
            cancelThrottle();
        },
    };
}
//# sourceMappingURL=trackViewportResize.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/trackers/trackMediaInteraction.js






function trackMediaInteraction(configuration, mediaInteractionCb) {
    return (0,addEventListener/* addEventListeners */.y)(configuration, document, ["play" /* DOM_EVENT.PLAY */, "pause" /* DOM_EVENT.PAUSE */], (event) => {
        const target = getEventTarget(event);
        if (!target ||
            (0,esm/* getNodePrivacyLevel */.IE)(target, configuration.defaultPrivacyLevel) === esm/* NodePrivacyLevel.HIDDEN */.zx.HIDDEN ||
            !hasSerializedNode(target)) {
            return;
        }
        mediaInteractionCb(assembleIncrementalSnapshot(IncrementalSource.MediaInteraction, {
            id: getSerializedNodeId(target),
            type: event.type === "play" /* DOM_EVENT.PLAY */ ? MediaInteractionType.Play : MediaInteractionType.Pause,
        }));
    }, {
        capture: true,
        passive: true,
    });
}
//# sourceMappingURL=trackMediaInteraction.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/instrumentMethod.js
var instrumentMethod = __webpack_require__(55801);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/trackers/trackStyleSheet.js




function trackStyleSheet(styleSheetCb) {
    function checkStyleSheetAndCallback(styleSheet, callback) {
        if (styleSheet && hasSerializedNode(styleSheet.ownerNode)) {
            callback(getSerializedNodeId(styleSheet.ownerNode));
        }
    }
    const instrumentationStoppers = [
        (0,instrumentMethod/* instrumentMethod */.S)(CSSStyleSheet.prototype, 'insertRule', ({ target: styleSheet, parameters: [rule, index] }) => {
            checkStyleSheetAndCallback(styleSheet, (id) => styleSheetCb(assembleIncrementalSnapshot(IncrementalSource.StyleSheetRule, {
                id,
                adds: [{ rule, index }],
            })));
        }),
        (0,instrumentMethod/* instrumentMethod */.S)(CSSStyleSheet.prototype, 'deleteRule', ({ target: styleSheet, parameters: [index] }) => {
            checkStyleSheetAndCallback(styleSheet, (id) => styleSheetCb(assembleIncrementalSnapshot(IncrementalSource.StyleSheetRule, {
                id,
                removes: [{ index }],
            })));
        }),
    ];
    if (typeof CSSGroupingRule !== 'undefined') {
        instrumentGroupingCSSRuleClass(CSSGroupingRule);
    }
    else {
        instrumentGroupingCSSRuleClass(CSSMediaRule);
        instrumentGroupingCSSRuleClass(CSSSupportsRule);
    }
    function instrumentGroupingCSSRuleClass(cls) {
        instrumentationStoppers.push((0,instrumentMethod/* instrumentMethod */.S)(cls.prototype, 'insertRule', ({ target: styleSheet, parameters: [rule, index] }) => {
            checkStyleSheetAndCallback(styleSheet.parentStyleSheet, (id) => {
                const path = getPathToNestedCSSRule(styleSheet);
                if (path) {
                    path.push(index || 0);
                    styleSheetCb(assembleIncrementalSnapshot(IncrementalSource.StyleSheetRule, {
                        id,
                        adds: [{ rule, index: path }],
                    }));
                }
            });
        }), (0,instrumentMethod/* instrumentMethod */.S)(cls.prototype, 'deleteRule', ({ target: styleSheet, parameters: [index] }) => {
            checkStyleSheetAndCallback(styleSheet.parentStyleSheet, (id) => {
                const path = getPathToNestedCSSRule(styleSheet);
                if (path) {
                    path.push(index);
                    styleSheetCb(assembleIncrementalSnapshot(IncrementalSource.StyleSheetRule, {
                        id,
                        removes: [{ index: path }],
                    }));
                }
            });
        }));
    }
    return {
        stop: () => {
            instrumentationStoppers.forEach((stopper) => stopper.stop());
        },
    };
}
function getPathToNestedCSSRule(rule) {
    const path = [];
    let currentRule = rule;
    while (currentRule.parentRule) {
        const rules = Array.from(currentRule.parentRule.cssRules);
        const index = rules.indexOf(currentRule);
        path.unshift(index);
        currentRule = currentRule.parentRule;
    }
    // A rule may not be attached to a stylesheet
    if (!currentRule.parentStyleSheet) {
        return;
    }
    const rules = Array.from(currentRule.parentStyleSheet.cssRules);
    const index = rules.indexOf(currentRule);
    path.unshift(index);
    return path;
}
//# sourceMappingURL=trackStyleSheet.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/trackers/trackFocus.js


function trackFocus(configuration, focusCb) {
    return (0,addEventListener/* addEventListeners */.y)(configuration, window, ["focus" /* DOM_EVENT.FOCUS */, "blur" /* DOM_EVENT.BLUR */], () => {
        focusCb({
            data: { has_focus: document.hasFocus() },
            type: RecordType.Focus,
            timestamp: (0,timeUtils/* timeStampNow */.n$)(),
        });
    });
}
//# sourceMappingURL=trackFocus.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/trackers/trackFrustration.js


function trackFrustration(lifeCycle, frustrationCb, recordIds) {
    const frustrationSubscription = lifeCycle.subscribe(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, (data) => {
        var _a, _b;
        if (data.rawRumEvent.type === esm/* RumEventType.ACTION */.D$.ACTION &&
            data.rawRumEvent.action.type === esm/* ActionType.CLICK */.Us.CLICK &&
            ((_b = (_a = data.rawRumEvent.action.frustration) === null || _a === void 0 ? void 0 : _a.type) === null || _b === void 0 ? void 0 : _b.length) &&
            'events' in data.domainContext &&
            data.domainContext.events &&
            data.domainContext.events.length) {
            frustrationCb({
                timestamp: data.rawRumEvent.date,
                type: RecordType.FrustrationRecord,
                data: {
                    frustrationTypes: data.rawRumEvent.action.frustration.type,
                    recordIds: data.domainContext.events.map((e) => recordIds.getIdForEvent(e)),
                },
            });
        }
    });
    return {
        stop: () => {
            frustrationSubscription.unsubscribe();
        },
    };
}
//# sourceMappingURL=trackFrustration.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/trackers/trackViewEnd.js


function trackViewEnd(lifeCycle, viewEndCb) {
    const viewEndSubscription = lifeCycle.subscribe(5 /* LifeCycleEventType.VIEW_ENDED */, () => {
        viewEndCb({
            timestamp: (0,timeUtils/* timeStampNow */.n$)(),
            type: RecordType.ViewEnd,
        });
    });
    return {
        stop: () => {
            viewEndSubscription.unsubscribe();
        },
    };
}
//# sourceMappingURL=trackViewEnd.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/trackers/trackInput.js






function trackInput(configuration, inputCb, target = document) {
    const defaultPrivacyLevel = configuration.defaultPrivacyLevel;
    const lastInputStateMap = new WeakMap();
    const isShadowRoot = target !== document;
    const { stop: stopEventListeners } = (0,addEventListener/* addEventListeners */.y)(configuration, target, 
    // The 'input' event bubbles across shadow roots, so we don't have to listen for it on shadow
    // roots since it will be handled by the event listener that we did add to the document. Only
    // the 'change' event is blocked and needs to be handled on shadow roots.
    isShadowRoot ? ["change" /* DOM_EVENT.CHANGE */] : ["input" /* DOM_EVENT.INPUT */, "change" /* DOM_EVENT.CHANGE */], (event) => {
        const target = getEventTarget(event);
        if (target instanceof HTMLInputElement ||
            target instanceof HTMLTextAreaElement ||
            target instanceof HTMLSelectElement) {
            onElementChange(target);
        }
    }, {
        capture: true,
        passive: true,
    });
    let stopPropertySetterInstrumentation;
    if (!isShadowRoot) {
        const instrumentationStoppers = [
            (0,instrumentMethod/* instrumentSetter */.X)(HTMLInputElement.prototype, 'value', onElementChange),
            (0,instrumentMethod/* instrumentSetter */.X)(HTMLInputElement.prototype, 'checked', onElementChange),
            (0,instrumentMethod/* instrumentSetter */.X)(HTMLSelectElement.prototype, 'value', onElementChange),
            (0,instrumentMethod/* instrumentSetter */.X)(HTMLTextAreaElement.prototype, 'value', onElementChange),
            (0,instrumentMethod/* instrumentSetter */.X)(HTMLSelectElement.prototype, 'selectedIndex', onElementChange),
        ];
        stopPropertySetterInstrumentation = () => {
            instrumentationStoppers.forEach((stopper) => stopper.stop());
        };
    }
    else {
        stopPropertySetterInstrumentation = functionUtils/* noop */.Z;
    }
    return {
        stop: () => {
            stopPropertySetterInstrumentation();
            stopEventListeners();
        },
    };
    function onElementChange(target) {
        const nodePrivacyLevel = (0,esm/* getNodePrivacyLevel */.IE)(target, defaultPrivacyLevel);
        if (nodePrivacyLevel === esm/* NodePrivacyLevel.HIDDEN */.zx.HIDDEN) {
            return;
        }
        const type = target.type;
        let inputState;
        if (type === 'radio' || type === 'checkbox') {
            if ((0,esm/* shouldMaskNode */.gR)(target, nodePrivacyLevel)) {
                return;
            }
            inputState = { isChecked: target.checked };
        }
        else {
            const value = getElementInputValue(target, nodePrivacyLevel);
            if (value === undefined) {
                return;
            }
            inputState = { text: value };
        }
        // Can be multiple changes on the same node within the same batched mutation observation.
        cbWithDedup(target, inputState);
        // If a radio was checked, other radios with the same name attribute will be unchecked.
        const name = target.name;
        if (type === 'radio' && name && target.checked) {
            document.querySelectorAll(`input[type="radio"][name="${CSS.escape(name)}"]`).forEach((el) => {
                if (el !== target) {
                    // TODO: Consider the privacy implications for various differing input privacy levels
                    cbWithDedup(el, { isChecked: false });
                }
            });
        }
    }
    /**
     * There can be multiple changes on the same node within the same batched mutation observation.
     */
    function cbWithDedup(target, inputState) {
        if (!hasSerializedNode(target)) {
            return;
        }
        const lastInputState = lastInputStateMap.get(target);
        if (!lastInputState ||
            lastInputState.text !== inputState.text ||
            lastInputState.isChecked !== inputState.isChecked) {
            lastInputStateMap.set(target, inputState);
            inputCb(assembleIncrementalSnapshot(IncrementalSource.Input, {
                id: getSerializedNodeId(target),
                ...inputState,
            }));
        }
    }
}
//# sourceMappingURL=trackInput.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/monitor.js
var monitor = __webpack_require__(64933);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/requestIdleCallback.js
var requestIdleCallback = __webpack_require__(21337);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/mutationBatch.js

/**
 * Maximum duration to wait before processing mutations. If the browser is idle, mutations will be
 * processed more quickly. If the browser is busy executing small tasks (ex: rendering frames), the
 * mutations will wait MUTATION_PROCESS_MAX_DELAY milliseconds before being processed. If the
 * browser is busy executing a longer task, mutations will be processed after this task.
 */
const MUTATION_PROCESS_MAX_DELAY = 100;
/**
 * Minimum duration to wait before processing mutations. This is used to batch mutations together
 * and be able to deduplicate them to save processing time and bandwidth.
 * 16ms is the duration of a frame at 60fps that ensure fluid UI.
 */
const MUTATION_PROCESS_MIN_DELAY = 16;
function createMutationBatch(processMutationBatch) {
    let cancelScheduledFlush = functionUtils/* noop */.Z;
    let pendingMutations = [];
    function flush() {
        cancelScheduledFlush();
        processMutationBatch(pendingMutations);
        pendingMutations = [];
    }
    const { throttled: throttledFlush, cancel: cancelThrottle } = (0,functionUtils/* throttle */.P)(flush, MUTATION_PROCESS_MIN_DELAY, {
        leading: false,
    });
    return {
        addMutations: (mutations) => {
            if (pendingMutations.length === 0) {
                cancelScheduledFlush = (0,requestIdleCallback/* requestIdleCallback */.Kk)(throttledFlush, { timeout: MUTATION_PROCESS_MAX_DELAY });
            }
            pendingMutations.push(...mutations);
        },
        flush,
        stop: () => {
            cancelScheduledFlush();
            cancelThrottle();
        },
    };
}
//# sourceMappingURL=mutationBatch.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/trackers/trackMutation.js






/**
 * Buffers and aggregate mutations generated by a MutationObserver into MutationPayload
 */
function trackMutation(mutationCallback, configuration, shadowRootsController, target) {
    const MutationObserver = (0,esm/* getMutationObserverConstructor */.q5)();
    if (!MutationObserver) {
        return { stop: functionUtils/* noop */.Z, flush: functionUtils/* noop */.Z };
    }
    const mutationBatch = createMutationBatch((mutations) => {
        processMutations(mutations.concat(observer.takeRecords()), mutationCallback, configuration, shadowRootsController);
    });
    const observer = new MutationObserver((0,monitor/* monitor */.zk)(mutationBatch.addMutations));
    observer.observe(target, {
        attributeOldValue: true,
        attributes: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true,
    });
    return {
        stop: () => {
            observer.disconnect();
            mutationBatch.stop();
        },
        flush: () => {
            mutationBatch.flush();
        },
    };
}
function processMutations(mutations, mutationCallback, configuration, shadowRootsController) {
    const nodePrivacyLevelCache = new Map();
    mutations
        .filter((mutation) => mutation.type === 'childList')
        .forEach((mutation) => {
        mutation.removedNodes.forEach((removedNode) => {
            traverseRemovedShadowDom(removedNode, shadowRootsController.removeShadowRoot);
        });
    });
    // Discard any mutation with a 'target' node that:
    // * isn't injected in the current document or isn't known/serialized yet: those nodes are likely
    // part of a mutation occurring in a parent Node
    // * should be hidden or ignored
    const filteredMutations = mutations.filter((mutation) => mutation.target.isConnected &&
        nodeAndAncestorsHaveSerializedNode(mutation.target) &&
        (0,esm/* getNodePrivacyLevel */.IE)(mutation.target, configuration.defaultPrivacyLevel, nodePrivacyLevelCache) !==
            esm/* NodePrivacyLevel.HIDDEN */.zx.HIDDEN);
    const serializationStats = createSerializationStats();
    const { adds, removes, hasBeenSerialized } = processChildListMutations(filteredMutations.filter((mutation) => mutation.type === 'childList'), configuration, serializationStats, shadowRootsController, nodePrivacyLevelCache);
    const texts = processCharacterDataMutations(filteredMutations.filter((mutation) => mutation.type === 'characterData' && !hasBeenSerialized(mutation.target)), configuration, nodePrivacyLevelCache);
    const attributes = processAttributesMutations(filteredMutations.filter((mutation) => mutation.type === 'attributes' && !hasBeenSerialized(mutation.target)), configuration, nodePrivacyLevelCache);
    if (!texts.length && !attributes.length && !removes.length && !adds.length) {
        return;
    }
    mutationCallback(assembleIncrementalSnapshot(IncrementalSource.Mutation, { adds, removes, texts, attributes }), serializationStats);
}
function processChildListMutations(mutations, configuration, serializationStats, shadowRootsController, nodePrivacyLevelCache) {
    // First, we iterate over mutations to collect:
    //
    // * nodes that have been added in the document and not removed by a subsequent mutation
    // * nodes that have been removed from the document but were not added in a previous mutation
    //
    // For this second category, we also collect their previous parent (mutation.target) because we'll
    // need it to emit a 'remove' mutation.
    //
    // Those two categories may overlap: if a node moved from a position to another, it is reported as
    // two mutation records, one with a "removedNodes" and the other with "addedNodes". In this case,
    // the node will be in both sets.
    const addedAndMovedNodes = new Set();
    const removedNodes = new Map();
    for (const mutation of mutations) {
        mutation.addedNodes.forEach((node) => {
            addedAndMovedNodes.add(node);
        });
        mutation.removedNodes.forEach((node) => {
            if (!addedAndMovedNodes.has(node)) {
                removedNodes.set(node, mutation.target);
            }
            addedAndMovedNodes.delete(node);
        });
    }
    // Then, we sort nodes that are still in the document by topological order, for two reasons:
    //
    // * We will serialize each added nodes with their descendants. We don't want to serialize a node
    // twice, so we need to iterate over the parent nodes first and skip any node that is contained in
    // a precedent node.
    //
    // * To emit "add" mutations, we need references to the parent and potential next sibling of each
    // added node. So we need to iterate over the parent nodes first, and when multiple nodes are
    // siblings, we want to iterate from last to first. This will ensure that any "next" node is
    // already serialized and have an id.
    const sortedAddedAndMovedNodes = Array.from(addedAndMovedNodes);
    sortAddedAndMovedNodes(sortedAddedAndMovedNodes);
    // Then, we iterate over our sorted node sets to emit mutations. We collect the newly serialized
    // node ids in a set to be able to skip subsequent related mutations.
    const serializedNodeIds = new Set();
    const serializationContext = {
        status: 2 /* SerializationContextStatus.MUTATION */,
        serializationStats,
        shadowRootsController,
    };
    const addedNodeMutations = [];
    for (const node of sortedAddedAndMovedNodes) {
        if (hasBeenSerialized(node)) {
            continue;
        }
        const parentNodePrivacyLevel = (0,esm/* getNodePrivacyLevel */.IE)(node.parentNode, configuration.defaultPrivacyLevel, nodePrivacyLevelCache);
        if (parentNodePrivacyLevel === esm/* NodePrivacyLevel.HIDDEN */.zx.HIDDEN || parentNodePrivacyLevel === esm/* NodePrivacyLevel.IGNORE */.zx.IGNORE) {
            continue;
        }
        const serializationStart = (0,timeUtils/* timeStampNow */.n$)();
        const serializedNode = serializeNodeWithId(node, {
            serializedNodeIds,
            parentNodePrivacyLevel,
            serializationContext,
            configuration,
        });
        updateSerializationStats(serializationStats, 'serializationDuration', (0,timeUtils/* elapsed */._J)(serializationStart, (0,timeUtils/* timeStampNow */.n$)()));
        if (!serializedNode) {
            continue;
        }
        const parentNode = (0,esm/* getParentNode */.Ow)(node);
        addedNodeMutations.push({
            nextId: getNextSibling(node),
            parentId: getSerializedNodeId(parentNode),
            node: serializedNode,
        });
    }
    // Finally, we emit remove mutations.
    const removedNodeMutations = [];
    removedNodes.forEach((parent, node) => {
        if (hasSerializedNode(node)) {
            removedNodeMutations.push({
                parentId: getSerializedNodeId(parent),
                id: getSerializedNodeId(node),
            });
        }
    });
    return { adds: addedNodeMutations, removes: removedNodeMutations, hasBeenSerialized };
    function hasBeenSerialized(node) {
        return hasSerializedNode(node) && serializedNodeIds.has(getSerializedNodeId(node));
    }
    function getNextSibling(node) {
        let nextSibling = node.nextSibling;
        while (nextSibling) {
            if (hasSerializedNode(nextSibling)) {
                return getSerializedNodeId(nextSibling);
            }
            nextSibling = nextSibling.nextSibling;
        }
        return null;
    }
}
function processCharacterDataMutations(mutations, configuration, nodePrivacyLevelCache) {
    var _a;
    const textMutations = [];
    // Deduplicate mutations based on their target node
    const handledNodes = new Set();
    const filteredMutations = mutations.filter((mutation) => {
        if (handledNodes.has(mutation.target)) {
            return false;
        }
        handledNodes.add(mutation.target);
        return true;
    });
    // Emit mutations
    for (const mutation of filteredMutations) {
        const value = mutation.target.textContent;
        if (value === mutation.oldValue) {
            continue;
        }
        const parentNodePrivacyLevel = (0,esm/* getNodePrivacyLevel */.IE)((0,esm/* getParentNode */.Ow)(mutation.target), configuration.defaultPrivacyLevel, nodePrivacyLevelCache);
        if (parentNodePrivacyLevel === esm/* NodePrivacyLevel.HIDDEN */.zx.HIDDEN || parentNodePrivacyLevel === esm/* NodePrivacyLevel.IGNORE */.zx.IGNORE) {
            continue;
        }
        textMutations.push({
            id: getSerializedNodeId(mutation.target),
            // TODO: pass a valid "ignoreWhiteSpace" argument
            value: (_a = (0,esm/* getTextContent */.FB)(mutation.target, false, parentNodePrivacyLevel)) !== null && _a !== void 0 ? _a : null,
        });
    }
    return textMutations;
}
function processAttributesMutations(mutations, configuration, nodePrivacyLevelCache) {
    const attributeMutations = [];
    // Deduplicate mutations based on their target node and changed attribute
    const handledElements = new Map();
    const filteredMutations = mutations.filter((mutation) => {
        const handledAttributes = handledElements.get(mutation.target);
        if (handledAttributes && handledAttributes.has(mutation.attributeName)) {
            return false;
        }
        if (!handledAttributes) {
            handledElements.set(mutation.target, new Set([mutation.attributeName]));
        }
        else {
            handledAttributes.add(mutation.attributeName);
        }
        return true;
    });
    // Emit mutations
    const emittedMutations = new Map();
    for (const mutation of filteredMutations) {
        const uncensoredValue = mutation.target.getAttribute(mutation.attributeName);
        if (uncensoredValue === mutation.oldValue) {
            continue;
        }
        const privacyLevel = (0,esm/* getNodePrivacyLevel */.IE)(mutation.target, configuration.defaultPrivacyLevel, nodePrivacyLevelCache);
        const attributeValue = serializeAttribute(mutation.target, privacyLevel, mutation.attributeName, configuration);
        let transformedValue;
        if (mutation.attributeName === 'value') {
            const inputValue = getElementInputValue(mutation.target, privacyLevel);
            if (inputValue === undefined) {
                continue;
            }
            transformedValue = inputValue;
        }
        else if (typeof attributeValue === 'string') {
            transformedValue = attributeValue;
        }
        else {
            transformedValue = null;
        }
        let emittedMutation = emittedMutations.get(mutation.target);
        if (!emittedMutation) {
            emittedMutation = {
                id: getSerializedNodeId(mutation.target),
                attributes: {},
            };
            attributeMutations.push(emittedMutation);
            emittedMutations.set(mutation.target, emittedMutation);
        }
        emittedMutation.attributes[mutation.attributeName] = transformedValue;
    }
    return attributeMutations;
}
function sortAddedAndMovedNodes(nodes) {
    nodes.sort((a, b) => {
        const position = a.compareDocumentPosition(b);
        /* eslint-disable no-bitwise */
        if (position & Node.DOCUMENT_POSITION_CONTAINED_BY) {
            return -1;
        }
        else if (position & Node.DOCUMENT_POSITION_CONTAINS) {
            return 1;
        }
        else if (position & Node.DOCUMENT_POSITION_FOLLOWING) {
            return 1;
        }
        else if (position & Node.DOCUMENT_POSITION_PRECEDING) {
            return -1;
        }
        /* eslint-enable no-bitwise */
        return 0;
    });
}
function traverseRemovedShadowDom(removedNode, shadowDomRemovedCallback) {
    if ((0,esm/* isNodeShadowHost */.aT)(removedNode)) {
        shadowDomRemovedCallback(removedNode.shadowRoot);
    }
    (0,esm/* forEachChildNodes */.Uo)(removedNode, (childNode) => traverseRemovedShadowDom(childNode, shadowDomRemovedCallback));
}
//# sourceMappingURL=trackMutation.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/trackers/index.js











//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/elementsScrollPositions.js
function createElementsScrollPositions() {
    const scrollPositionsByElement = new WeakMap();
    return {
        set(element, scrollPositions) {
            if (element === document && !document.scrollingElement) {
                // cf https://drafts.csswg.org/cssom-view/#dom-document-scrollingelement,
                // in some cases scrolling elements can not be defined, we don't support those for now
                return;
            }
            scrollPositionsByElement.set(element === document ? document.scrollingElement : element, scrollPositions);
        },
        get(element) {
            return scrollPositionsByElement.get(element);
        },
        has(element) {
            return scrollPositionsByElement.has(element);
        },
    };
}
//# sourceMappingURL=elementsScrollPositions.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/shadowRootsController.js

const initShadowRootsController = (configuration, callback, elementsScrollPositions) => {
    const controllerByShadowRoot = new Map();
    const shadowRootsController = {
        addShadowRoot: (shadowRoot) => {
            if (controllerByShadowRoot.has(shadowRoot)) {
                return;
            }
            const mutationTracker = trackMutation(callback, configuration, shadowRootsController, shadowRoot);
            // The change event does not bubble up across the shadow root, we have to listen on the shadow root
            const inputTracker = trackInput(configuration, callback, shadowRoot);
            // The scroll event does not bubble up across the shadow root, we have to listen on the shadow root
            const scrollTracker = trackScroll(configuration, callback, elementsScrollPositions, shadowRoot);
            controllerByShadowRoot.set(shadowRoot, {
                flush: () => mutationTracker.flush(),
                stop: () => {
                    mutationTracker.stop();
                    inputTracker.stop();
                    scrollTracker.stop();
                },
            });
        },
        removeShadowRoot: (shadowRoot) => {
            const entry = controllerByShadowRoot.get(shadowRoot);
            if (!entry) {
                // unidentified root cause: observed in some cases with shadow DOM added by browser extensions
                return;
            }
            entry.stop();
            controllerByShadowRoot.delete(shadowRoot);
        },
        stop: () => {
            controllerByShadowRoot.forEach(({ stop }) => stop());
        },
        flush: () => {
            controllerByShadowRoot.forEach(({ flush }) => flush());
        },
    };
    return shadowRootsController;
};
//# sourceMappingURL=shadowRootsController.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/startFullSnapshots.js





function startFullSnapshots(elementsScrollPositions, shadowRootsController, lifeCycle, configuration, flushMutations, emit) {
    const takeFullSnapshot = (timestamp, status) => {
        const { width, height } = (0,esm/* getViewportDimension */.PA)();
        emit({
            data: {
                height,
                href: window.location.href,
                width,
            },
            type: RecordType.Meta,
            timestamp,
        });
        emit({
            data: {
                has_focus: document.hasFocus(),
            },
            type: RecordType.Focus,
            timestamp,
        });
        const serializationStats = createSerializationStats();
        const serializationContext = {
            status,
            elementsScrollPositions,
            serializationStats,
            shadowRootsController,
        };
        emit({
            data: {
                node: serializeDocument(document, configuration, serializationContext),
                initialOffset: {
                    left: (0,esm/* getScrollX */.$1)(),
                    top: (0,esm/* getScrollY */.X_)(),
                },
            },
            type: RecordType.FullSnapshot,
            timestamp,
        }, serializationStats);
        if (window.visualViewport) {
            emit({
                data: getVisualViewport(window.visualViewport),
                type: RecordType.VisualViewport,
                timestamp,
            });
        }
    };
    takeFullSnapshot((0,timeUtils/* timeStampNow */.n$)(), 0 /* SerializationContextStatus.INITIAL_FULL_SNAPSHOT */);
    const { unsubscribe } = lifeCycle.subscribe(2 /* LifeCycleEventType.VIEW_CREATED */, (view) => {
        flushMutations();
        takeFullSnapshot(view.startClocks.timeStamp, 1 /* SerializationContextStatus.SUBSEQUENT_FULL_SNAPSHOT */);
    });
    return {
        stop: unsubscribe,
    };
}
//# sourceMappingURL=startFullSnapshots.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/recordIds.js
function initRecordIds() {
    const recordIds = new WeakMap();
    let nextId = 1;
    return {
        getIdForEvent(event) {
            if (!recordIds.has(event)) {
                recordIds.set(event, nextId++);
            }
            return recordIds.get(event);
        },
    };
}
//# sourceMappingURL=recordIds.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/record.js







function record(options) {
    const { emit, configuration, lifeCycle } = options;
    // runtime checks for user options
    if (!emit) {
        throw new Error('emit function is required');
    }
    const emitAndComputeStats = (record, stats) => {
        emit(record, stats);
        (0,sendToExtension/* sendToExtension */.j)('record', { record });
        const view = options.viewHistory.findView();
        replayStats/* addRecord */.xK(view.id);
    };
    const elementsScrollPositions = createElementsScrollPositions();
    const shadowRootsController = initShadowRootsController(configuration, emitAndComputeStats, elementsScrollPositions);
    const { stop: stopFullSnapshots } = startFullSnapshots(elementsScrollPositions, shadowRootsController, lifeCycle, configuration, flushMutations, emitAndComputeStats);
    function flushMutations() {
        shadowRootsController.flush();
        mutationTracker.flush();
    }
    const recordIds = initRecordIds();
    const mutationTracker = trackMutation(emitAndComputeStats, configuration, shadowRootsController, document);
    const trackers = [
        mutationTracker,
        trackMove(configuration, emitAndComputeStats),
        trackMouseInteraction(configuration, emitAndComputeStats, recordIds),
        trackScroll(configuration, emitAndComputeStats, elementsScrollPositions, document),
        trackViewportResize(configuration, emitAndComputeStats),
        trackInput(configuration, emitAndComputeStats),
        trackMediaInteraction(configuration, emitAndComputeStats),
        trackStyleSheet(emitAndComputeStats),
        trackFocus(configuration, emitAndComputeStats),
        trackVisualViewportResize(configuration, emitAndComputeStats),
        trackFrustration(lifeCycle, emitAndComputeStats, recordIds),
        trackViewEnd(lifeCycle, (viewEndRecord) => {
            flushMutations();
            emitAndComputeStats(viewEndRecord);
        }),
    ];
    return {
        stop: () => {
            shadowRootsController.stop();
            trackers.forEach((tracker) => tracker.stop());
            stopFullSnapshots();
        },
        flushMutations,
        shadowRootsController,
    };
}
//# sourceMappingURL=record.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/index.js




//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/browser/pageMayExitObservable.js
var pageMayExitObservable = __webpack_require__(47581);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/timer.js
var timer = __webpack_require__(65483);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/segmentCollection/buildReplayPayload.js
function buildReplayPayload(data, metadata, stats, rawSegmentBytesCount) {
    const formData = new FormData();
    formData.append('segment', new Blob([data], {
        type: 'application/octet-stream',
    }), `${metadata.session.id}-${metadata.start}`);
    const metadataAndSegmentSizes = {
        raw_segment_size: rawSegmentBytesCount,
        compressed_segment_size: data.byteLength,
        ...metadata,
    };
    const serializedMetadataAndSegmentSizes = JSON.stringify(metadataAndSegmentSizes);
    formData.append('event', new Blob([serializedMetadataAndSegmentSizes], { type: 'application/json' }));
    return {
        data: formData,
        bytesCount: data.byteLength,
        cssText: stats.cssText,
        isFullSnapshot: metadata.index_in_view === 0,
        rawSize: rawSegmentBytesCount,
        recordCount: metadata.records_count,
        serializationDuration: stats.serializationDuration,
    };
}
//# sourceMappingURL=buildReplayPayload.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/segmentCollection/segment.js



function createSegment({ context, creationReason, encoder, }) {
    let encodedBytesCount = 0;
    const viewId = context.view.id;
    const indexInView = replayStats/* getSegmentsCount */.FT(viewId);
    const metadata = {
        start: Infinity,
        end: -Infinity,
        creation_reason: creationReason,
        records_count: 0,
        has_full_snapshot: false,
        index_in_view: indexInView,
        source: 'browser',
        ...context,
    };
    const serializationStats = createSerializationStats();
    replayStats/* addSegment */.ui(viewId);
    function addRecord(record, stats, callback) {
        metadata.start = Math.min(metadata.start, record.timestamp);
        metadata.end = Math.max(metadata.end, record.timestamp);
        metadata.records_count += 1;
        metadata.has_full_snapshot || (metadata.has_full_snapshot = record.type === RecordType.FullSnapshot);
        if (stats) {
            aggregateSerializationStats(serializationStats, stats);
        }
        const prefix = encoder.isEmpty ? '{"records":[' : ',';
        encoder.write(prefix + JSON.stringify(record), (additionalEncodedBytesCount) => {
            encodedBytesCount += additionalEncodedBytesCount;
            callback(encodedBytesCount);
        });
    }
    function flush(callback) {
        if (encoder.isEmpty) {
            throw new Error('Empty segment flushed');
        }
        encoder.write(`],${JSON.stringify(metadata).slice(1)}\n`);
        encoder.finish((encoderResult) => {
            replayStats/* addWroteData */.pk(metadata.view.id, encoderResult.rawBytesCount);
            callback(metadata, serializationStats, encoderResult);
        });
    }
    return { addRecord, flush };
}
//# sourceMappingURL=segment.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/segmentCollection/segmentCollection.js



const SEGMENT_DURATION_LIMIT = 5 * timeUtils/* ONE_SECOND */.WT;
/**
 * beacon payload max queue size implementation is 64kb
 * ensure that we leave room for logs, rum and potential other users
 */
let SEGMENT_BYTES_LIMIT = 60000;
function startSegmentCollection(lifeCycle, configuration, sessionManager, viewHistory, httpRequest, encoder) {
    return doStartSegmentCollection(lifeCycle, () => computeSegmentContext(configuration.applicationId, sessionManager, viewHistory), httpRequest, encoder);
}
function doStartSegmentCollection(lifeCycle, getSegmentContext, httpRequest, encoder) {
    let state = {
        status: 0 /* SegmentCollectionStatus.WaitingForInitialRecord */,
        nextSegmentCreationReason: 'init',
    };
    const { unsubscribe: unsubscribeViewCreated } = lifeCycle.subscribe(2 /* LifeCycleEventType.VIEW_CREATED */, () => {
        flushSegment('view_change');
    });
    const { unsubscribe: unsubscribePageMayExit } = lifeCycle.subscribe(11 /* LifeCycleEventType.PAGE_MAY_EXIT */, (pageMayExitEvent) => {
        flushSegment(pageMayExitEvent.reason);
    });
    function flushSegment(flushReason) {
        if (state.status === 1 /* SegmentCollectionStatus.SegmentPending */) {
            state.segment.flush((metadata, stats, encoderResult) => {
                const payload = buildReplayPayload(encoderResult.output, metadata, stats, encoderResult.rawBytesCount);
                if ((0,pageMayExitObservable/* isPageExitReason */.PT)(flushReason)) {
                    httpRequest.sendOnExit(payload);
                }
                else {
                    httpRequest.send(payload);
                }
            });
            (0,timer/* clearTimeout */.gr)(state.expirationTimeoutId);
        }
        if (flushReason !== 'stop') {
            state = {
                status: 0 /* SegmentCollectionStatus.WaitingForInitialRecord */,
                nextSegmentCreationReason: flushReason,
            };
        }
        else {
            state = {
                status: 2 /* SegmentCollectionStatus.Stopped */,
            };
        }
    }
    return {
        addRecord: (record, stats) => {
            if (state.status === 2 /* SegmentCollectionStatus.Stopped */) {
                return;
            }
            if (state.status === 0 /* SegmentCollectionStatus.WaitingForInitialRecord */) {
                const context = getSegmentContext();
                if (!context) {
                    return;
                }
                state = {
                    status: 1 /* SegmentCollectionStatus.SegmentPending */,
                    segment: createSegment({ encoder, context, creationReason: state.nextSegmentCreationReason }),
                    expirationTimeoutId: (0,timer/* setTimeout */.iK)(() => {
                        flushSegment('segment_duration_limit');
                    }, SEGMENT_DURATION_LIMIT),
                };
            }
            state.segment.addRecord(record, stats, (encodedBytesCount) => {
                if (encodedBytesCount > SEGMENT_BYTES_LIMIT) {
                    flushSegment('segment_bytes_limit');
                }
            });
        },
        stop: () => {
            flushSegment('stop');
            unsubscribeViewCreated();
            unsubscribePageMayExit();
        },
    };
}
function computeSegmentContext(applicationId, sessionManager, viewHistory) {
    const session = sessionManager.findTrackedSession();
    const viewContext = viewHistory.findView();
    if (!session || !viewContext) {
        return undefined;
    }
    return {
        application: {
            id: applicationId,
        },
        session: {
            id: session.id,
        },
        view: {
            id: viewContext.id,
        },
    };
}
function setSegmentBytesLimit(newSegmentBytesLimit = 60000) {
    SEGMENT_BYTES_LIMIT = newSegmentBytesLimit;
}
//# sourceMappingURL=segmentCollection.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/numberUtils.js
var numberUtils = __webpack_require__(73603);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/segmentCollection/startSegmentTelemetry.js

const SEGMENT_METRICS_TELEMETRY_NAME = 'Segment network request metrics';
function startSegmentTelemetry(configuration, telemetry, requestObservable) {
    const segmentTelemetryEnabled = telemetry.enabled && (0,numberUtils/* performDraw */.y7)(configuration.replayTelemetrySampleRate);
    if (!segmentTelemetryEnabled) {
        return { stop: functionUtils/* noop */.Z };
    }
    const { unsubscribe } = requestObservable.subscribe((requestEvent) => {
        if (requestEvent.type === 'failure' ||
            requestEvent.type === 'queue-full' ||
            (requestEvent.type === 'success' && requestEvent.payload.isFullSnapshot)) {
            const metrics = createSegmentMetrics(requestEvent.type, requestEvent.bandwidth, requestEvent.payload);
            (0,telemetry_telemetry/* addTelemetryMetrics */.qZ)(SEGMENT_METRICS_TELEMETRY_NAME, { metrics });
        }
    });
    return {
        stop: unsubscribe,
    };
}
function createSegmentMetrics(result, bandwidthStats, payload) {
    return {
        cssText: {
            count: payload.cssText.count,
            max: payload.cssText.max,
            sum: payload.cssText.sum,
        },
        isFullSnapshot: payload.isFullSnapshot,
        ongoingRequests: {
            count: bandwidthStats.ongoingRequestCount,
            totalSize: bandwidthStats.ongoingByteCount,
        },
        recordCount: payload.recordCount,
        result,
        serializationDuration: {
            count: payload.serializationDuration.count,
            max: payload.serializationDuration.max,
            sum: payload.serializationDuration.sum,
        },
        size: {
            compressed: payload.bytesCount,
            raw: payload.rawSize,
        },
    };
}
//# sourceMappingURL=startSegmentTelemetry.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/segmentCollection/index.js



//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/startRecordBridge.js

function startRecordBridge(viewHistory) {
    const bridge = (0,eventBridge/* getEventBridge */.Ad)();
    return {
        addRecord: (record) => {
            // Get the current active view, not at the time of the record, aligning with the segment logic.
            // This approach could potentially associate the record to an incorrect view, in case the record date is in the past (e.g. frustration records).
            // However the risk is minimal. We could address the issue when potential negative impact are identified.
            const view = viewHistory.findView();
            bridge.send('record', record, view.id);
        },
    };
}
//# sourceMappingURL=startRecordBridge.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/boot/startRecording.js




function startRecording(lifeCycle, configuration, sessionManager, viewHistory, encoder, telemetry, httpRequest) {
    const cleanupTasks = [];
    const reportError = (error) => {
        lifeCycle.notify(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, { error });
        (0,telemetry_telemetry/* addTelemetryDebug */.eJ)('Error reported to customer', { 'error.message': error.message });
    };
    const replayRequest = httpRequest || (0,transport_httpRequest/* createHttpRequest */.UF)([configuration.sessionReplayEndpointBuilder], SEGMENT_BYTES_LIMIT, reportError);
    let addRecord;
    if (!(0,eventBridge/* canUseEventBridge */.xT)()) {
        const segmentCollection = startSegmentCollection(lifeCycle, configuration, sessionManager, viewHistory, replayRequest, encoder);
        addRecord = segmentCollection.addRecord;
        cleanupTasks.push(segmentCollection.stop);
        const segmentTelemetry = startSegmentTelemetry(configuration, telemetry, replayRequest.observable);
        cleanupTasks.push(segmentTelemetry.stop);
    }
    else {
        ;
        ({ addRecord } = startRecordBridge(viewHistory));
    }
    const { stop: stopRecording } = record({
        emit: addRecord,
        configuration,
        lifeCycle,
        viewHistory,
    });
    cleanupTasks.push(stopRecording);
    return {
        stop: () => {
            cleanupTasks.forEach((task) => task());
        },
    };
}
//# sourceMappingURL=startRecording.js.map

/***/ })

}]);